import { atomWithReset } from 'jotai/utils';

interface UserInCompanyConfiguration {
  vehicleDwellTimeThresholdMinutes: number | undefined;
  isUserSessionInvalidationOnUiInactivityEnabled: boolean;
}

export const userInCompanyConfigurationState = atomWithReset<UserInCompanyConfiguration | undefined>(undefined);

export const companyDefaultDwellTimeThresholdState = atomWithReset<number | undefined>(undefined);
